import { BaseModel, SearchParameter } from './base.model';

export class UserComment extends BaseModel {
  userId: string;
  referralId: string;
  type: number;
  comment: string;
}